import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Input from '../../../../../Input/Input';
import Button from '../../../../../Button/Button';

interface Props {
	name: string;
	description: string;
	onSave: (name: string, desc: string) => void;
	open: boolean;
	onClose?: () => void;
}

const EditDetails: React.FC<Props> = props => {
	const nameRef = React.useRef<HTMLInputElement>(null);
	const descRef = React.useRef<HTMLInputElement>(null);
	
	const onSave = () => {
		props.onSave(
			nameRef.current.value,
			descRef.current.value
		);

		props.onClose();
	};

	return <Dialog onClose={props.onClose} maxWidth="lg" open={props.open}>
		<div className="addCollection__popupWrapper">
			<div className="addCollection__header">
				Настройка отображения
			</div>

			<div className="addCollection__section">
				<Input
					defaultValue={props.name}
					label="Название"
					inputProps={{
						ref: nameRef
					}}
				/>
			</div>

			<div className="addCollection__section">
				<Input
					ref={descRef}
					defaultValue={props.description}
					label="Описание"
					multiline={true}
					inputProps={{
						ref: descRef
					}}
				/>
			</div>

			<div>
				<Button type="primary" onClick={onSave}>
					Сохранить
				</Button>
			</div>
		</div>
	</Dialog>
};

export default EditDetails;
